import React from "react";
import useWindowDimensions from "../get-diemensions/UseWindowDiemensions";
import { MenuDisplayHeader } from "../components";
import { useNavigate } from "react-router-dom";

const Practioner = () => {
  const { width, height } = useWindowDimensions();
  const navigate = useNavigate();
  return (
    <div style={{ width: width, position: "relative" }}>
      <MenuDisplayHeader
        selected={"practioners"}
        onAboutClick={() => navigate("/")}
        onPharmaciesClick={() => navigate("/pharmacies")}
        onLegalityClick={() => navigate("/legality")}
      />
      Practioner
    </div>
  );
};

export default Practioner;
